import {
  FeedbackServiceClient
} from "@/proto/feedback_grpc_web_pb";
import { 
  Feedback, 
  ListFeedbackRequest,
  FeedbackFilter,
  FeedbackSort,
  FeedbackPagination,
  CreateFeedbackRequest,  
  UpdateFeedbackRequest, 
  DeleteFeedbackRequest
} from "@/proto/feedback_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;

export class FeedbackApi {
  items: Array<Feedback> = [];
  client: FeedbackServiceClient;


  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new FeedbackServiceClient(host, null, null);
  }

  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }

  // Установка и получение фильтров
  createFilter(data: any){

    const filter = new FeedbackFilter();
    const feedbackDesc:string = data.feedbackDesc !== undefined ? data.feedbackDesc.toString() : "";
    const email:string = data.email !== undefined ? data.email.toString() : "";
    const lastName:string = data.lastName !== undefined ? data.lastName.toString() : "";
    const firstName:string = data.firstName !== undefined ? data.firstName.toString() : "";
    const middleName:string = data.middleName !== undefined ? data.middleName.toString() : "";

    // Устанавливаем фильтры
    filter.setFeedbackDesc(feedbackDesc);
    filter.setEmail(email);
    filter.setLastName(lastName);
    filter.setFirstName(firstName);
    filter.setMiddleName(middleName);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new FeedbackSort();
    const name:string = data.name !== undefined ? data.name.toString() : "feedback_name";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "asc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new FeedbackPagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getFeedbackItems(filter: any, sort: any, pagination: any){

    const request = new ListFeedbackRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listFeedback(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Создание элемента
  createFeedbackItem(data: any){

    const request = new CreateFeedbackRequest();
    request.setFeedbackId(data.feedbackId);
    request.setUserId(data.userId);
    request.setFeedbackDesc(data.feedbackDesc);
    request.setCreatedDate(data.createdDate);

    return new Promise((resolve, reject) => {
      this.client.createFeedback(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateFeedbackItem(data: any){

    const request = new UpdateFeedbackRequest();
    request.setFeedbackId(data.feedbackId);
    request.setUserId(data.userId);
    request.setFeedbackDesc(data.feedbackDesc);
    request.setCreatedDate(data.createdDate);

    return new Promise((resolve, reject) => {
      this.client.updateFeedback(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteFeedbackItem(data: any){

    const request = new DeleteFeedbackRequest();
    request.setFeedbackId(data.feedbackId);

    return new Promise((resolve, reject) => {
      this.client.deleteFeedback(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }
}